import React from "react";
import { Grid2, Typography, Box, useMediaQuery } from "@mui/material";
import NSELogo from "../../../ui-utils/latestPics/MultiExg.png"; // Example icons, replace with actual paths
import BotIcon from "../../../ui-utils/latestPics/CustTrdBot.png";
import PortfolioIcon from "../../../ui-utils/latestPics/Diverse.png";
import StrategyIcon from "../../../ui-utils/latestPics/Isolation_Mode.png";
import Grid from "@mui/material/Grid2";
import MultiExchangeWebStyle from "./MultiExchangeWeb.module.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import en from "../../../i18n/English/Home/exchange.json";
import hi from "../../../i18n/Hindi/Home/exchange.json";
import kn from "../../../i18n/Kannada/Home/exchange.json";
import ma from "../../../i18n/Marathi/Home/exchange.json";
import gu from "../../../i18n/Gujarati/Home/exchange.json";
import { useLanguage } from "../../../Context/LangContext";

export default function MultiExchangeWeb() {
  const isSmallScreen = useMediaQuery("(max-width:1250px)");
    const { language } = useLanguage();
    const translations = { en, hi, kn  ,gu,ma };
  const t = translations[language] || translations.en ;
  return (
    <Box
      sx={{
        backgroundColor: "#FFF6EE !important",
        minHeight: "100vh",
        width: "100%",
        overflow:"hidden"
      }}
    >
      <Box
        className={MultiExchangeWebStyle.innerBox}>
        {/* Header Section */}

        <AnimationOnScroll animateIn="animate__fadeInDown"
          animateOnce={true}
          className={MultiExchangeWebStyle.customFadeInLeft}>


          {/* <Typography
            className={MultiExchangeWebStyle.multih1heading}
            style={{ fontWeight: 600 }}
          >
            {t.keyFeatures}
          </Typography> */}

          <div className={MultiExchangeWebStyle.headingContainer}>
            <div className={MultiExchangeWebStyle.gradientBackground}></div>
            <Typography className={MultiExchangeWebStyle.multih1heading} style={{ fontWeight: 600 }}>
              {t.keyFeatures}
            </Typography>
          </div>

          <Typography
            variant="body1"
            className={MultiExchangeWebStyle.multipara1}
            sx={{ fontWeight: 400 }}
          >
            {/* Experience Seamless Trading with Tradeboss Multi Exchange Trading
            Platform! */}
            {t.experienceSeamless}
          </Typography>

          <Typography
            // variant="body1"
            className={MultiExchangeWebStyle.multipara2}
          >
            {/* The Tradeboss Multi Exchange Trading Platform stands at the forefront
            of investment technology, offering a robust solution for investors
            looking to maximize their market reach. This cutting-edge platform
            allows you to engage with multiple trading platforms and stock trading
            accounts, ensuring comprehensive access to diverse stock markets. */}
            {t.description}
          </Typography>
        </AnimationOnScroll>
        {/* Key Features Section */}

        {
          isSmallScreen ? <>
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                rowSpacing={5}
                columnSpacing={{
                  xs: 2.5,
                  sm: 5.5,
                  md: 6.5,
                  lg: "162px",
                  xl: "300px",
                }}
              >
                <Grid size={6} className={MultiExchangeWebStyle.mainCard1}>
                  {/* <Item>1</Item> */}
                  <AnimationOnScroll animateIn="animate__fadeInLeft"
                    animateOnce={true}
                    className={MultiExchangeWebStyle.customFadeInLeft}>
                    <Box className={MultiExchangeWebStyle.cardWrapper} sx={{ position: 'relative' }}>

                      <div className={MultiExchangeWebStyle.cardgradientBackground}></div>
                      <Box className={MultiExchangeWebStyle.multiflexcolumn1} sx={{ position: 'relative', zIndex: 2 }}>

                        <Box
                          component="img"
                          src={NSELogo}
                          alt="Multi Exchange Access"
                          sx={{ width: "139px", height: "139px", marginBottom: "16px" }}
                          className={MultiExchangeWebStyle.multivectorimgtop}
                        />
                        <Typography
                          variant="h6"
                          className={MultiExchangeWebStyle.multikeytitle} style={{ fontWeight: 600 }}
                        >
                          {/* Multi Exchange Access */}
                          {t.multiExchangeTitle}
                        </Typography>
                        <Typography
                          variant="body2"
                          className={MultiExchangeWebStyle.multitlepara}
                        >
                          {/* Connect seamlessly to various exchanges including NSE, BSE,
                          and more. Whether you're into stock trading, mutual funds, or
                          other investment options, our platform provides unmatched
                          versatility. */}
                          {t.multiExchangeDesc}
                        </Typography>
                      </Box>
                    </Box>
                  </AnimationOnScroll>
                </Grid>
                <Grid size={6} className={MultiExchangeWebStyle.mainCard1}>
                  {/* <Item>2</Item> */}
                  <AnimationOnScroll animateIn="animate__fadeInRight"
                    animateOnce={true}
                    className={MultiExchangeWebStyle.customFadeInLeft}>
                    <Box className={MultiExchangeWebStyle.cardWrapper} sx={{ position: 'relative' }}>
                      <div className={MultiExchangeWebStyle.cardgradientBackground}></div>
                      <Box className={MultiExchangeWebStyle.multiflexcolumn1} sx={{ position: 'relative', zIndex: 2 }}>
                        <Box
                          component="img"
                          src={BotIcon}
                          alt="Customizable Trading Bots"
                          sx={{ width: "139px", height: "139px", marginBottom: "16px" }}
                          className={MultiExchangeWebStyle.multivectorimgtop}
                        />
                        <Typography
                          variant="h6"
                          className={MultiExchangeWebStyle.multikeytitle}
                        >
                          {/* Customizable Trading Bots */}
                          {t.botsTitle}
                        </Typography>
                        <Typography
                          variant="body2"
                          className={MultiExchangeWebStyle.multitlepara}
                        >
                          {/* Leverage our state-of-the-art technology by configuring
                          personalized robots. These robots can trade autonomously
                          across different exchanges based on the scripts and investment
                          strategies that align with your financial goals. */}
                          {t.botsDesc}
                        </Typography>
                      </Box>
                    </Box>
                  </AnimationOnScroll>
                </Grid>
                <Grid size={6} className={MultiExchangeWebStyle.mainCard1}>
                  {/* <Item>3</Item> */}
                  <AnimationOnScroll animateIn="animate__fadeInLeft"
                    animateOnce={true}
                    className={MultiExchangeWebStyle.customFadeInLeft}>
                    <Box className={MultiExchangeWebStyle.cardWrapper} sx={{ position: 'relative' }}>
                      <div className={MultiExchangeWebStyle.cardgradientBackground}></div>
                      <Box className={MultiExchangeWebStyle.multiflexcolumn1} sx={{ position: 'relative', zIndex: 2 }}>
                        <Box
                          component="img"
                          src={PortfolioIcon}
                          alt="Diverse Portfolio Management"
                          sx={{ width: "155px", height: "155px", marginBottom: "16px" }}
                          className={MultiExchangeWebStyle.multivectorimgbottom}
                        />
                        <Typography
                          variant="h6"
                          className={MultiExchangeWebStyle.multikeytitle}
                        >
                          {/* Diverse Portfolio Management */}
                          {t.portfolioTitle}
                        </Typography>
                        <Typography
                          variant="body2"
                          className={MultiExchangeWebStyle.multitlepara}
                        >
                          {/* With Tradeboss, manage a diverse portfolio effortlessly. Our
                          platform supports a wide range of assets from direct mutual
                          funds to complex derivatives, catering to both new investors
                          and seasoned traders. */}
                          {t.portfolioDesc}
                        </Typography>
                      </Box>
                    </Box>
                  </AnimationOnScroll>
                </Grid>
                <Grid size={6} className={MultiExchangeWebStyle.mainCard1}>
                  {/* <Item>4</Item> */}
                  <AnimationOnScroll animateIn="animate__fadeInRight"
                    animateOnce={true}
                    className={MultiExchangeWebStyle.customFadeInLeft}>
                    <Box className={MultiExchangeWebStyle.cardWrapper} sx={{ position: 'relative' }}>
                      <div className={MultiExchangeWebStyle.cardgradientBackground}></div>
                      <Box className={MultiExchangeWebStyle.multiflexcolumn1} sx={{ position: 'relative', zIndex: 2 }}>
                        <Box
                          component="img"
                          src={StrategyIcon}
                          alt="Optimized Trading Strategies"
                          sx={{ width: "152px", height: "152px", marginBottom: "16px" }}
                          className={MultiExchangeWebStyle.multivectorimgbottom}
                        />
                        <Typography
                          variant="h6"
                          className={MultiExchangeWebStyle.multikeytitle}
                        >
                          {/* Optimized Trading Strategies */}
                          {t.strategiesTitle}
                        </Typography>
                        <Typography
                          variant="body2"
                          className={MultiExchangeWebStyle.multitlepara}
                        >
                          {/* Utilize advanced stock market apps and trading tools
                          integrated into our platform to refine your trading
                          strategies. These tools help in buying stocks, managing stock
                          market investments, and optimizing trading accounts for
                          maximum efficiency. */}
                          {t.strategiesDesc}
                        </Typography>
                      </Box>
                    </Box>
                  </AnimationOnScroll>
                </Grid>
              </Grid>
            </Box>
          </> :
            <>
              <Box sx={{ width: "100%" }}>
                <Grid
                  container
                  rowSpacing={5}
                  columnSpacing={{
                    xs: 2.5,
                    sm: 5.5,
                    md: 6.5,
                    lg: "48px",
                    xl: "72px",
                  }}
                >
                  {/* <Grid size={6} className={MultiExchangeWebStyle.mainCard}>

                    <AnimationOnScroll animateIn="animate__fadeInLeft"
                      animateOnce={true}
                      className={MultiExchangeWebStyle.customFadeInLeft}>
                      <Grid2 sx={{
                        background: "#ffffff", width: "226px", height: "226px", borderRadius: "50%" ,position: 'absolute',
                        transform: 'translateX(-50%)',
                        zIndex: 1,
                        top:"35px",
                        left:"220px",
                      } }/>
                  <Box className={MultiExchangeWebStyle.multiflexcolumn}>
                    <Box
                      component="img"
                      src={NSELogo}
                      alt="Multi Exchange Access"
                      sx={{ width: "167px", height: "144px", marginBottom: "16px"}}
                      className={MultiExchangeWebStyle.multivectorimgtop}
                    />

                    <Grid2 className={MultiExchangeWebStyle.card1}>

                      <Typography
                        variant="h6"
                        className={MultiExchangeWebStyle.multikeytitle}
                      >
                        Multi Exchange Access
                      </Typography>
                      <Typography
                        variant="body2"
                        className={MultiExchangeWebStyle.multitlepara}
                      >
                        Connect seamlessly to various exchanges including NSE, BSE,
                        and more. Whether you're into stock trading, mutual funds, or
                        other investment options, our platform provides unmatched
                        versatility.
                      </Typography>
                    </Grid2>

                  </Box>
                  </AnimationOnScroll>
                </Grid> */}
                  <Grid size={6} className={MultiExchangeWebStyle.mainCard}>
                    <AnimationOnScroll
                      animateIn="animate__fadeInLeft"
                      animateOnce={true}
                      className={MultiExchangeWebStyle.customFadeInLeft}
                    >
                      <Box className={MultiExchangeWebStyle.cardWrapper} sx={{ position: 'relative' }}>

                        {/* Circle Background (hidden by default, visible on hover) */}
                        {/* <Grid2 className={MultiExchangeWebStyle.circleBackground} /> */}
                        <div className={MultiExchangeWebStyle.cardgradientBackground}></div>

                        {/* Foreground Content */}
                        <Box className={MultiExchangeWebStyle.multiflexcolumn} sx={{ position: 'relative', zIndex: 2 }}>
                          <Box
                            component="img"
                            src={NSELogo}
                            alt="Multi Exchange Access"
                            sx={{ width: "167px", height: "144px", marginBottom: "16px" }}
                            className={MultiExchangeWebStyle.multivectorimgtop}
                          />

                          <Grid2 className={MultiExchangeWebStyle.card1}>
                            <Typography variant="h6" className={MultiExchangeWebStyle.multikeytitle} style={{ fontWeight: 500 }}>
                              {/* Multi Exchange Access */}
                              {t.multiExchangeTitle}
                            </Typography>
                            <Typography variant="body2" className={MultiExchangeWebStyle.multitlepara}>
                              {/* Connect seamlessly to various exchanges including NSE, BSE, and more. Whether you're into stock trading, mutual funds, or other investment options, our platform provides unmatched versatility. */}

                              {t.multiExchangeDesc}
                            </Typography>
                          </Grid2>
                        </Box>

                      </Box>
                    </AnimationOnScroll>
                  </Grid>

                  {/* <Grid size={6} className={MultiExchangeWebStyle.mainCard}>

                    <AnimationOnScroll animateIn="animate__fadeInRight"
                      animateOnce={true}
                      className={MultiExchangeWebStyle.customFadeInLeft}>
                  <Box className={MultiExchangeWebStyle.multiflexcolumn}>
                    <Box
                      component="img"
                      src={BotIcon}
                      alt="Customizable Trading Bots"
                      sx={{ width: "144px", height: "132px", marginBottom: "16px" }}
                      className={MultiExchangeWebStyle.multivectorimgtop}
                    />

                    <Grid2 className={MultiExchangeWebStyle.card2}>
                      <Typography
                        variant="h6"
                        className={MultiExchangeWebStyle.multikeytitle}
                      >
                        Customizable Trading Bots
                      </Typography>
                      <Typography
                        variant="body2"
                        className={MultiExchangeWebStyle.multitlepara}
                      >
                        Leverage our state-of-the-art technology by configuring
                        personalized robots. These robots can trade autonomously
                        across different exchanges based on the scripts and investment
                        strategies that align with your financial goals.
                      </Typography>
                    </Grid2>

                  </Box>
                  </AnimationOnScroll>
                </Grid>
                  <Grid size={6} className={MultiExchangeWebStyle.mainCard}>

                    <AnimationOnScroll animateIn="animate__fadeInLeft"
                      animateOnce={true}
                      className={MultiExchangeWebStyle.customFadeInLeft}>
                  <Box className={MultiExchangeWebStyle.multiflexcolumn} >
                    <Box
                      component="img"
                      src={PortfolioIcon}
                      alt="Diverse Portfolio Management"
                      sx={{ width: "188px", height: "159px", marginBottom: "16px", paddingLeft: "2px" }}
                      className={MultiExchangeWebStyle.multivectorimgbottom}
                    />

                    <Grid2 className={MultiExchangeWebStyle.card3}
                    >
                      <Typography
                        variant="h6"
                        className={MultiExchangeWebStyle.multikeytitle}
                      >
                        Diverse Portfolio Management
                      </Typography>
                      <Typography
                        variant="body2"
                        className={MultiExchangeWebStyle.multitlepara}
                      >
                        Manage a diverse portfolio effortlessly. Our platform supports a wide range of assets from direct mutual funds to complex derivatives, catering to both new investors and seasoned traders.
                      </Typography>
                    </Grid2>
                  </Box>
                  </AnimationOnScroll>
                </Grid>
                  <Grid size={6} className={MultiExchangeWebStyle.mainCard}>

                    <AnimationOnScroll animateIn="animate__fadeInRight"
                      animateOnce={true}
                      className={MultiExchangeWebStyle.customFadeInLeft}>

                  <Box className={MultiExchangeWebStyle.multiflexcolumn}>
                    <Box
                      component="img"
                      src={StrategyIcon}
                      alt="Optimized Trading Strategies"
                      sx={{ width: "154px", height: "132px", marginBottom: "16px" }}
                      className={MultiExchangeWebStyle.multivectorimgbottom}
                    />

                    <Grid2 className={MultiExchangeWebStyle.card4}>
                      <Typography
                        variant="h6"
                        className={MultiExchangeWebStyle.multikeytitle}
                      >
                        Optimized Trading Strategies
                      </Typography>
                      <Typography
                        variant="body2"
                        className={MultiExchangeWebStyle.multitlepara}
                      >
                        Utilize advanced stock market apps and trading tools
                        integrated into our platform to refine your trading
                        strategies. These tools help in buying stocks, managing stock
                        market investments, and optimizing trading accounts for
                        maximum efficiency.
                      </Typography>
                    </Grid2>
                  </Box>
                  </AnimationOnScroll>
                </Grid> */}

                  <Grid size={6} className={MultiExchangeWebStyle.mainCard}>
                    <AnimationOnScroll animateIn="animate__fadeInRight" animateOnce={true} className={MultiExchangeWebStyle.customFadeInLeft}>
                      <Box className={MultiExchangeWebStyle.cardWrapper} sx={{ position: 'relative' }}>

                        {/* Circle Background */}
                        <div className={MultiExchangeWebStyle.cardgradientBackground}></div>

                        <Box className={MultiExchangeWebStyle.multiflexcolumn} sx={{ position: 'relative', zIndex: 2 }}>
                          <Box
                            component="img"
                            src={BotIcon}
                            alt="Customizable Trading Bots"
                            sx={{ width: "144px", height: "132px", marginBottom: "16px" }}
                            className={MultiExchangeWebStyle.multivectorimgtop}
                          />

                          <Grid2 className={MultiExchangeWebStyle.card2}>
                            <Typography variant="h6" className={MultiExchangeWebStyle.multikeytitle}>
                              {/* Customizable Trading Bots */}
                              {t.botsTitle}
                            </Typography>
                            <Typography variant="body2" className={MultiExchangeWebStyle.multitlepara}>
                              {/* Leverage our state-of-the-art technology by configuring personalized robots. These robots can trade autonomously across different exchanges based on the scripts and investment strategies that align with your financial goals. */}

                              {t.botsDesc}
                            </Typography>
                          </Grid2>
                        </Box>

                      </Box>
                    </AnimationOnScroll>
                  </Grid>

                  <Grid size={6} className={MultiExchangeWebStyle.mainCard}>
                    <AnimationOnScroll animateIn="animate__fadeInLeft" animateOnce={true} className={MultiExchangeWebStyle.customFadeInLeft}>
                      <Box className={MultiExchangeWebStyle.cardWrapper} sx={{ position: 'relative' }}>

                        <div className={MultiExchangeWebStyle.cardgradientBackground}></div>

                        <Box className={MultiExchangeWebStyle.multiflexcolumn} sx={{ position: 'relative', zIndex: 2 }}>
                          <Box
                            component="img"
                            src={PortfolioIcon}
                            alt="Diverse Portfolio Management"
                            sx={{ width: "188px", height: "159px", marginBottom: "16px", paddingLeft: "2px" }}
                            className={MultiExchangeWebStyle.multivectorimgbottom}
                          />

                          <Grid2 className={MultiExchangeWebStyle.card3}>
                            <Typography variant="h6" className={MultiExchangeWebStyle.multikeytitle}>
                              {/* Diverse Portfolio Management */}
                              {t.portfolioTitle}
                            </Typography>
                            <Typography variant="body2" className={MultiExchangeWebStyle.multitlepara}>
                              {/* Manage a diverse portfolio effortlessly. Our platform supports a wide range of assets from direct mutual funds to complex derivatives, catering to both new investors and seasoned traders. */}
                              {t.portfolioDesc}
                            </Typography>
                          </Grid2>
                        </Box>

                      </Box>
                    </AnimationOnScroll>
                  </Grid>

                  <Grid size={6} className={MultiExchangeWebStyle.mainCard}>
                    <AnimationOnScroll animateIn="animate__fadeInRight" animateOnce={true} className={MultiExchangeWebStyle.customFadeInLeft}>
                      <Box className={MultiExchangeWebStyle.cardWrapper} sx={{ position: 'relative' }}>

                        <div className={MultiExchangeWebStyle.cardgradientBackground}></div>

                        <Box className={MultiExchangeWebStyle.multiflexcolumn} sx={{ position: 'relative', zIndex: 2 }}>
                          <Box
                            component="img"
                            src={StrategyIcon}
                            alt="Optimized Trading Strategies"
                            sx={{ width: "154px", height: "132px", marginBottom: "16px" }}
                            className={MultiExchangeWebStyle.multivectorimgbottom}
                          />

                          <Grid2 className={MultiExchangeWebStyle.card4}>
                            <Typography variant="h6" className={MultiExchangeWebStyle.multikeytitle}>
                              {/* Optimized Trading Strategies */}
                              {t.strategiesTitle}
                            </Typography>
                            <Typography variant="body2" className={MultiExchangeWebStyle.multitlepara}>
                              {/* Utilize advanced stock market apps and trading tools integrated into our platform to refine your trading strategies. These tools help in buying stocks, managing stock market investments, and optimizing trading accounts for maximum efficiency. */}
                              {t.strategiesDesc}
                            </Typography>
                          </Grid2>
                        </Box>

                      </Box>
                    </AnimationOnScroll>
                  </Grid>

                </Grid>
              </Box>
            </>
        }


      </Box>
    </Box>
  );
}
